import { render } from "./parseMarkdown.vue?vue&type=template&id=efbd74ca&scoped=true&ts=true"
import script from "./parseMarkdown.vue?vue&type=script&lang=ts"
export * from "./parseMarkdown.vue?vue&type=script&lang=ts"

import "./parseMarkdown.vue?vue&type=style&index=0&id=efbd74ca&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbd74ca"]])

export default __exports__